/**
 * Derives bookmark / like flags from userInteractions API responses (same shapes as MahaAgX).
 */
export function parseBookmarkLikeFromUserInteractions(
  response: unknown,
): { bookmarked: boolean; liked: boolean } {
  const r = response as Record<string, unknown> | null;
  if (!r || typeof r !== 'object') {
    return { bookmarked: false, liked: false };
  }
  const items: unknown[] =
    (Array.isArray(r['result']) ? r['result'] : null) ??
    (Array.isArray(r['results']) ? r['results'] : null) ??
    (Array.isArray(r['data']) ? r['data'] : null) ??
    [];
  const first = (items[0] ?? {}) as Record<string, unknown>;
  const userInteraction = first['userInteraction'] as Record<string, unknown> | undefined;
  const ad = (first['assetDetails'] ?? first) as Record<string, unknown>;

  let bookmarked = false;
  const bm =
    typeof userInteraction?.['bookmarked'] === 'boolean'
      ? userInteraction['bookmarked']
      : typeof first['isBookmarked'] === 'boolean'
        ? first['isBookmarked']
        : typeof first['bookmarked'] === 'boolean'
          ? first['bookmarked']
          : typeof ad['bookmarked'] === 'boolean'
            ? ad['bookmarked']
            : null;
  if (bm !== null) {
    bookmarked = bm;
  } else {
    const actionTypes = items
      .map((it) =>
        String(
          (it as Record<string, unknown>)['actionType'] ??
            (it as Record<string, unknown>)['type'] ??
            (it as Record<string, unknown>)['interactionType'] ??
            '',
        ).toUpperCase(),
      )
      .filter(Boolean);
    bookmarked = actionTypes.includes('BOOKMARK');
  }

  let liked = false;
  const lk =
    typeof userInteraction?.['liked'] === 'boolean'
      ? userInteraction['liked']
      : typeof first['isLiked'] === 'boolean'
        ? first['isLiked']
        : typeof first['liked'] === 'boolean'
          ? first['liked']
          : typeof ad['liked'] === 'boolean'
            ? ad['liked']
            : null;
  if (lk !== null) {
    liked = lk;
  } else {
    const actionTypes = items
      .map((it) =>
        String(
          (it as Record<string, unknown>)['actionType'] ??
            (it as Record<string, unknown>)['type'] ??
            (it as Record<string, unknown>)['interactionType'] ??
            '',
        ).toUpperCase(),
      )
      .filter(Boolean);
    liked = actionTypes.includes('LIKE');
  }

  return { bookmarked, liked };
}
